import { BalanceType } from './balance.interface';

/** Tile states inside the `grid` the server returns once a game is finalized. */
export enum MineStatus {
  UNCHECKED = 0,
  SAFE = 1,
  HIT = 2,
}

export type GameStatus = 'active' | 'finished';
export type RoundOutcome = 'win' | 'loss' | 'error';
export type AutoStatus = 'idle' | 'running' | 'stopping';

interface BaseMines {
  balancetype?: BalanceType;
  won?: boolean;
  value?: number;
  status?: GameStatus;
  grid_size?: number;
  mines?: number;
  results?: number[];
  hash?: string;
  outcome?: number;
}

/** `load_mines` returns the grid as a position -> state map. */
export interface MinesLoad extends BaseMines {
  grid: Record<string, number>;
}

/** `select_mine` (finalized) and `cashout_mines` return the grid as a flat array. */
export interface MinesGame extends BaseMines {
  grid: number[];
}
